import React from "react";

import { SkeletonWrapper } from "components";

interface InsightCardProps {
  loading?: boolean;
  label: string;
  children: React.ReactNode;
  secondaryStat?: string;
  className?: string;
  attach?: "left" | "right";
  status?: "success" | "alert" | string;
}

// Attach can be used to join multiple cards, can be either "right" or "left"
export const InsightCard = ({ loading, label, children, secondaryStat, className, attach, status }: InsightCardProps) => (
  <div
    className={`farm-stat ${className} ${status === "alert" ? "alert" : ""} ${attach === "left" ? "attach-left" : ""} ${
      attach === "right" ? "attach-right" : ""
    }`}
  >
    <div className="stats-column">
      <SkeletonWrapper isLoading={loading} type="button" buttonShape="round" buttonSize="small">
        <div className="stats">
          <span className={`h1 ${status ? (status === "success" ? "green-text" : "red-text") : ""}`}>{children}</span>
          {secondaryStat && (
            <span className={`paragraph-m margin-left-25 ${status ? (status === "success" ? "green-text" : "red-text") : ""}`}>{secondaryStat}</span>
          )}
        </div>
      </SkeletonWrapper>

      <span className="paragraph-m">{label}</span>
    </div>
  </div>
);
